import { C } from 'xadmin-ui'

export default {
  context: (app) => (context, cb) => {
    const models = app.get('models')
    Object.values(models).forEach(model => {
      if(model.is_extend) {
        if(model.components == undefined || model.components == null) {
          model.components = {}
        }
        if(model.partialSave == undefined) {
          model.partialSave = true
        }
        if(model.components['ListPage'] == undefined) {
          model.components['ListPage'] = C('Model.ExtendListPage')
        }
        if(model.components['AddPage'] == undefined) {
          model.components['AddPage'] = C('Model.ExtendFormPage')
        }
        if(model.components['EditPage'] == undefined) {
          model.components['EditPage'] = C('Model.ExtendFormPage')
        }
        // if(model.components['page_detail'] == undefined) {
        //   model.components['page_detail'] = ModelDetailPage
        // }
      }
    })
    cb(null, context)
  }
}
